export default {
    methods: {
        setPrice(price) {
            return price / 100
        },
    },
}
